import React from 'react';
import PropTypes from 'prop-types';
import { Box, CircularProgress } from '@mui/material';

const Loader = ({ size = 36, sx }) => (
  <Box
    role="status"
    aria-label="Loading"
    sx={{
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      py: 5,
      ...sx,
    }}
  >
    <CircularProgress size={size} sx={{ color: '#287094' }} />
  </Box>
);

Loader.propTypes = {
  size: PropTypes.number,
  sx: PropTypes.object,
};

export default Loader;
